import React, { useEffect, useState } from 'react';

import { Paper, RadioGroup } from '@material-ui/core';

import { LabeledRadioButton } from '../labeled-radio-button';

type Props = ReduxFormFieldProps<FinalizingHireStepUpdateSettingType | null>;
const FINALIZING_HIRE_UPDATE_SETTINGS: Record<string, FinalizingHireStepUpdateSettingType> = {
  ALL: 'all',
  FUTURE: 'future',
};

const isFinalizingHireSetting = (value: string): value is FinalizingHireStepUpdateSettingType =>
  Object.values(FINALIZING_HIRE_UPDATE_SETTINGS).includes(
    value as FinalizingHireStepUpdateSettingType,
  );

export const JobFinalizingHireUpdateSettingReduxFormField = (props: Props) => {
  const [finalizingHireStepSetting, setFinalizingHireStepSetting] =
    useState<FinalizingHireStepUpdateSettingType | null>(null);

  useEffect(() => {
    setFinalizingHireStepSetting(props.input.value);
  }, [props.input.value]);

  const handleUpdateSettingChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    if (isFinalizingHireSetting(value)) {
      setFinalizingHireStepSetting(value);
      props.input.onChange(value);
    }
  };

  // We want ALL to be the default because we think that updating prehire steps for current and existing applicants is optimal behavior
  // When we are first creating a job, we wont have a jobId and finalizingHireStepSetting will be null.
  return (
    <Paper className="u-padding u-margin-top">
      <RadioGroup
        value={finalizingHireStepSetting || FINALIZING_HIRE_UPDATE_SETTINGS.ALL}
        onChange={handleUpdateSettingChange}
        className="u-no-padding"
        name="base-cadence"
      >
        <LabeledRadioButton
          value={FINALIZING_HIRE_UPDATE_SETTINGS.ALL}
          label="Apply changes to current and future onboarding applicants"
        />
        <LabeledRadioButton
          value={FINALIZING_HIRE_UPDATE_SETTINGS.FUTURE}
          label="Apply changes to future onboarding applicants only"
        />
      </RadioGroup>
    </Paper>
  );
};
